import React from 'react';
export const Founder = () => {
  return <div className="w-full bg-gray-100 py-12 Founder" data-id="element-62">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-63">
        <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-64">
          <div className="md:w-1/3" data-id="element-65">
            <div className="text-center" data-id="element-66">
              <h2 className="text-xl font-bold text-green-900 mb-2" data-id="element-67">
                From Our Founder...
              </h2>
              <p className="text-sm text-gray-500 mb-4" data-id="element-68">
                Featured by Top Websites!
              </p>
              <div className="mb-6" data-id="element-69">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rxMnyuFKXJUiSFH7bbxSnx/enhanced-image_%283%29.jpg" alt="Dr. Sarah Chan" className="w-32 h-32 object-cover rounded-full mx-auto mb-4" data-id="element-70" />
                <h3 className="font-bold" data-id="element-71">
                  Dr. Sarah Chen | Founder, Snouty & Co.
                </h3>
                <p className="text-sm text-gray-600" data-id="element-72">
                  Canine Nutritionist, PhD & Max's Guardian
                </p>
              </div>
            </div>
          </div>
          <div className="md:w-2/3" data-id="element-73">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-74">
              <p className="text-gray-700 mb-6 italic" data-id="element-75">
                "I formulated The Daily Foundation Chew™ to address the root
                cause of so many issues I saw in my own dog, Max. Bad breath is
                often the first warning sign of a gut imbalance that can lead to
                system-wide inflammation. The combination of soil-based
                probiotics and our Ancestral Core Blend™ is designed to restore
                that balance from the inside out. It's the solution I wish I'd
                had for Max years ago."
              </p>

              <p className="text-sm text-center text-gray-500" data-id="element-76">
                Featured in: Modern Dog Magazine, Whole Dog Journal, PetMD,
                Natural Dog Health
              </p>
            </div>
            <div className="text-center mt-6" data-id="element-77">
              <button className="bg-amber-600 text-white font-semibold py-3 px-8 rounded-full hover:bg-amber-500 transition" onClick={() => {
              const testimonialsSection = document.querySelector('.Testimonials');
              if (testimonialsSection) {
                testimonialsSection.scrollIntoView({
                  behavior: 'smooth'
                });
              } else {
                // Fallback if Testimonials class doesn't exist
                const sections = document.querySelectorAll('.w-full');
                const founderIndex = Array.from(sections).findIndex(section => section.classList.contains('Founder'));
                if (founderIndex !== -1 && sections[founderIndex + 1]) {
                  sections[founderIndex + 1].scrollIntoView({
                    behavior: 'smooth'
                  });
                }
              }
            }} data-id="element-78">
                Learn More About Our Story
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};